import React from "react"
import PropTypes from "prop-types"
import { motion } from "framer-motion"
import "bootstrap/dist/css/bootstrap.css"
import "jquery/dist/jquery"
import "@splidejs/splide/dist/css/themes/splide-default.min.css"

import "./layout.css"
import { Footer } from "./Footer"

const Layout = ({ children }) => {
  const classTitle = "footer"

  return (
    <>
      <motion.main
        className="main-section"
        initial={{ opacity: 0, x: -100 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: 100 }}
        transition={{
          type: "spring",
          mass: 0.35,
          stiffness: 75,
          duration: 0.3,
        }}
      >
        {children}
      </motion.main>
      <Footer
        classTitle={classTitle}
        style={{
          marginTop: `2rem`,
        }}
      />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
